import { LegalPage } from '../components/LegalPage';

export default function Datenschutz() {
  return (
    <LegalPage title="Datenschutzerkl&auml;rung" isPlaceholder={false}>
      <h2>1. Verantwortlicher</h2>
      <address>
        StartKlar.Digital Agentur<br />
        Christine &amp; Andreas Helm GbR<br />
        Clara-Schumann-Str. 2<br />
        97980 Bad Mergentheim<br />
        Deutschland
      </address>
      <p>
        Telefon: +49 152 - 07 42 93 38<br />
        E-Mail:{' '}
        <a
          href="mailto:info@startklar.digital"
          className="text-blue-600 hover:text-blue-700 underline"
        >
          info@startklar.digital
        </a>
      </p>

      <h2>2. Allgemeines zur Datenverarbeitung</h2>
      <p>
        Diese Datenschutzerkl&auml;rung informiert &uuml;ber die Verarbeitung personenbezogener Daten im Rahmen der Nutzung des Online-Tools <strong>berater-digital.de</strong>.
      </p>
      <p>
        Das Tool dient der Erstellung, Bearbeitung und Optimierung von Inhalten (z.&nbsp;B. Beratungsberichte) unter Einsatz automatisierter Prozesse sowie K&uuml;nstlicher Intelligenz (KI).
      </p>
      <p>
        Die Verarbeitung erfolgt auf Grundlage der Datenschutz-Grundverordnung (DSGVO) sowie des Telekommunikation-Telemedien-Datenschutz-Gesetzes (TTDSG).
      </p>

      <h2>3. Arten der verarbeiteten Daten</h2>
      <p>Im Rahmen der Nutzung des Tools verarbeiten wir insbesondere:</p>
      <ul>
        <li>Bestandsdaten (z.&nbsp;B. Name, E-Mail-Adresse, Unternehmensdaten)</li>
        <li>Zugangsdaten (z.&nbsp;B. Login-Daten, Authentifizierungsinformationen)</li>
        <li>Inhaltsdaten (z.&nbsp;B. eingegebene Texte, generierte Inhalte, Dokumente)</li>
        <li>Nutzungsdaten (z.&nbsp;B. Aktionen innerhalb des Tools, Zugriffszeiten)</li>
        <li>Metadaten (z.&nbsp;B. IP-Adresse, technische Informationen)</li>
      </ul>

      <h2>4. Zwecke der Verarbeitung</h2>
      <p>Die Verarbeitung erfolgt zu folgenden Zwecken:</p>
      <ul>
        <li>Bereitstellung und Betrieb des Tools</li>
        <li>Erstellung und Generierung von Inhalten</li>
        <li>Verarbeitung von Nutzereingaben mittels KI-Systemen</li>
        <li>Verwaltung von Benutzerkonten</li>
        <li>Verbesserung und Weiterentwicklung der Plattform</li>
        <li>Gew&auml;hrleistung von Sicherheit und Stabilit&auml;t</li>
      </ul>

      <h2>5. Rechtsgrundlagen</h2>
      <p>Die Verarbeitung erfolgt auf Grundlage von:</p>
      <ul>
        <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserf&uuml;llung)</li>
        <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung, soweit erforderlich)</li>
        <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Betrieb, Sicherheit und Optimierung)</li>
      </ul>

      <h2>6. Einsatz von K&uuml;nstlicher Intelligenz (KI)</h2>
      <p>
        Zur Generierung und Verarbeitung von Inhalten nutzen wir externe KI-Dienste (z.&nbsp;B. Anbieter wie OpenAI oder Anthropic).
      </p>
      <p>
        Dabei k&ouml;nnen Nutzereingaben (z.&nbsp;B. Texte, Inhalte oder Strukturinformationen) an diese Dienste &uuml;bermittelt und dort verarbeitet werden.
      </p>
      <p>
        Eine Verarbeitung kann auch auf Servern au&szlig;erhalb der Europ&auml;ischen Union erfolgen.
      </p>
      <p>
        Wir stellen sicher, dass geeignete Datenschutzma&szlig;nahmen bestehen (z.&nbsp;B. Standardvertragsklauseln gem&auml;&szlig; Art. 46 DSGVO).
      </p>
      <p>
        <strong>Hinweis:</strong> Nutzer sollten keine sensiblen personenbezogenen Daten eingeben, sofern dies nicht zwingend erforderlich ist.
      </p>

      <h2>7. Hosting und technische Infrastruktur</h2>
      <p>
        Die Bereitstellung des Tools erfolgt &uuml;ber Server, die f&uuml;r einen sicheren und stabilen Betrieb notwendig sind.
      </p>
      <p>
        Dabei werden personenbezogene Daten im Rahmen der Nutzung und Systemverarbeitung gespeichert und verarbeitet.
      </p>

      <h2>8. Speicherung und L&ouml;schung von Daten</h2>
      <p>
        Personenbezogene Daten werden nur so lange gespeichert, wie es f&uuml;r die jeweiligen Zwecke erforderlich ist.
      </p>

      <h3>Kontodaten</h3>
      <p>Werden gespeichert, solange ein Nutzerkonto besteht.</p>

      <h3>Inhaltsdaten</h3>
      <p>
        Werden im Rahmen der Nutzung durch den Nutzer gespeichert und k&ouml;nnen jederzeit durch den Nutzer gel&ouml;scht werden.
      </p>

      <h3>Kontol&ouml;schung und Aufbewahrung</h3>
      <p>
        Wenn ein Nutzer die L&ouml;schung seines Kontos veranlasst, werden die zugeh&ouml;rigen personenbezogenen Daten grunds&auml;tzlich gel&ouml;scht.
      </p>
      <p>
        Zur Vermeidung unbeabsichtigter Datenverluste behalten wir uns jedoch vor, die Daten f&uuml;r einen Zeitraum von bis zu 30 Tagen nach L&ouml;schanforderung in gesperrter Form aufzubewahren.
      </p>
      <p>
        W&auml;hrend dieses Zeitraums ist eine Wiederherstellung des Kontos auf Wunsch des Nutzers m&ouml;glich.
      </p>
      <p>
        Nach Ablauf dieser Frist werden die Daten vollst&auml;ndig und unwiderruflich gel&ouml;scht, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
      </p>
      <p>
        Unabh&auml;ngig davon werden Daten auf ausdr&uuml;cklichen Wunsch des Nutzers unverz&uuml;glich gel&ouml;scht, sofern keine gesetzlichen Verpflichtungen zur weiteren Speicherung bestehen.
      </p>

      <h2>9. Weitergabe von Daten</h2>
      <p>Eine Weitergabe personenbezogener Daten erfolgt nur, wenn:</p>
      <ul>
        <li>dies zur Bereitstellung der Funktionen erforderlich ist</li>
        <li>externe Dienstleister (z.&nbsp;B. KI-Anbieter) eingebunden sind</li>
        <li>eine gesetzliche Verpflichtung besteht</li>
      </ul>

      <h2>10. Sicherheit</h2>
      <p>
        Wir setzen technische und organisatorische Ma&szlig;nahmen ein, um personenbezogene Daten vor Verlust, Manipulation oder unbefugtem Zugriff zu sch&uuml;tzen.
      </p>

      <h2>11. Rechte der betroffenen Personen</h2>
      <p>Sie haben das Recht auf:</p>
      <ul>
        <li>Auskunft</li>
        <li>Berichtigung</li>
        <li>L&ouml;schung</li>
        <li>Einschr&auml;nkung der Verarbeitung</li>
        <li>Daten&uuml;bertragbarkeit</li>
        <li>Widerruf einer Einwilligung</li>
      </ul>

      <h2>12. Beschwerderecht</h2>
      <p>
        Sie haben das Recht, sich bei einer Datenschutzaufsichtsbeh&ouml;rde zu beschweren.
      </p>

      <h2>13. Widerspruchsrecht</h2>
      <p>
        Sie k&ouml;nnen der Verarbeitung Ihrer Daten jederzeit widersprechen, sofern diese auf Art. 6 Abs. 1 lit. f DSGVO beruht.
      </p>

      <h2>14. &Auml;nderungen dieser Datenschutzerkl&auml;rung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerkl&auml;rung anzupassen, um sie an ge&auml;nderte rechtliche oder technische Anforderungen anzupassen.
      </p>
    </LegalPage>
  );
}
